<template>
  <div>
    <div
      class="text-sm weight-600 title m-3 text-center"
      id="gives-day-resources-title"
    >
      Gives Day Resources
    </div>
    <div
      v-if="!companyAdminStore.resourcesLoading && companyAdminStore.resources.length === 0"
      class="no-donations text-center"
      role="status"
      aria-live="polite"
      data-test="no-resources"
    >
      No resources available at the moment.
    </div>
    <div
      v-if="companyAdminStore.resourcesLoading"
      class="flex flex-wrap gap-x-[1.5rem] gap-y-5 justify-center md:justify-start"
      aria-labelledby="gives-day-resources-title"
    >
      <div
        v-for="index in 3"
        :key="`skeleton_${index}`"
        class="resource-card skeleton-card"
        aria-hidden="true"
        data-test="skeleton-card"
      >
        <p>
          <Skeleton
            height="1rem"
            class="mb-2 w-full"
          />
          <Skeleton
            height="1rem"
            class="mb-2 w-full"
          />
        </p>
        <Skeleton
          height="2rem"
          width="6rem"
          class="mt-3"
        />
      </div>
    </div>
    <div
      v-else
      class="flex flex-wrap gap-x-[1.5rem] gap-y-5 justify-center md:justify-start"
      aria-labelledby="gives-day-resources-title"
    >
      <div
        v-for="(resource, index) in companyAdminStore.resources"
        :key="`resource_${index}`"
        class="resource-card"
        role="group"
        :aria-labelledby="`resource-title-${index}`"
        data-test="resource-card"
      >
        <div
          class="resource-name"
          :id="`resource-title-${index}`"
        >
          {{ resource.fileName }}
        </div>
        <div class="resource-description">
          {{ resource.description }}
        </div>
        <a
          :href="generateDownloadUrl(resource.contentFiles_id)"
          :download="resource.fileName"
          class="download-link"
          target="_blank"
          :aria-label="`Download ${resource.fileName}`"
        >
          <Button
            variant="outlined"
            size="small"
          >
            Download
          </Button>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onBeforeMount } from 'vue';
import CryptoJS from 'crypto-js';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';

const companyAdminStore = useCompanyAdminStore();

const generateDownloadUrl = (fileId) => {
  const string = 'contentFiles_file_' + fileId + '_salt9800_giving_affiliate';
  const md5Hash = CryptoJS.MD5(string).toString();

  return `https://fw.civicore.com/giving_affiliate/app.neongivingdays.com/index.php?downloadFile=1&table=contentFiles&field=file&check=${md5Hash}&key=${fileId}`;
};
</script>

<style>
.resource-card {
  width: 288px;
  height: 130px;
  padding: 8px 32px 8px 16px;
  background: var(--White, #fff);
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  justify-content: space-between;
  align-items: flex-start;
}
.fundraiser-card.is-loading {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
}
.resource-name {
  width: 240px;
  color: #000;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
}
.resource-description {
  width: 240px;
  color: #000;
  font-family: Poppins;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
}
</style>
